import { Multiname } from '../abc/lazy/Multiname';
import { getCurrentABC } from '../run/getCurrentABC';
export function FlashUtilScript_getDefinitionByName(sec, name) {
    var simpleName = String(name).replace('::', '.');
    return getCurrentABC().env.app.getClass(Multiname.FromFQNString(simpleName, 0 /* NamespaceType.Public */));
}
